import {Dayjs} from 'dayjs'

/** Two-letter weekday labels used by every night-shift date, indexed by `Dayjs.day()`. */
export const NIGHT_WEEKDAYS: Record<number, string> = {
  0: 'Di',
  1: 'Lu',
  2: 'Ma',
  3: 'Me',
  4: 'Je',
  5: 'Ve',
  6: 'Sa',
}

export const formatNightShiftDate = (
  date: Dayjs,
  length: 'minimal' | 'short' | 'medium' | 'full' = 'full',
) => {
  const dayIndexToday = date.day()
  const dateYesterday = date.subtract(1, 'day')
  const dateYesterdayIndex = dateYesterday.day()

  switch (length) {
    case 'minimal':
      return `${dateYesterday.locale('fr').format('DD')}/${date.locale('fr').format('DD')}`
    case 'short':
      return `${NIGHT_WEEKDAYS[dateYesterdayIndex]}/${NIGHT_WEEKDAYS[dayIndexToday]}`
    case 'medium':
      return `${NIGHT_WEEKDAYS[dateYesterdayIndex]}/${NIGHT_WEEKDAYS[dayIndexToday]} ${dateYesterday.locale('fr').format('DD')}/${date.locale('fr').format('DD')}`
    case 'full':
      return `${NIGHT_WEEKDAYS[dateYesterdayIndex]}/${NIGHT_WEEKDAYS[dayIndexToday]} ${dateYesterday.locale('fr').format('DD')}/${date.locale('fr').format('DD')} ${date.locale('fr').format('MMM')}`
  }
}
